import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gallery-loading-spinner',
  templateUrl: './gallery-loading-spinner.component.html',
  styleUrls: ['./gallery-loading-spinner.component.scss']
})
export class GalleryLoadingSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
